const API_END_POINT = {
  USER: {
    CREATE_ACCESS_TOKEN: '/users/refresh-access-token',
    FETCH_CURRENT_USER: '/users/current-user',
    FETCH_ALARM: '/users/alarm-list',
    UPDATE_CONFIRM_ALARM: '/users/confirm-alarm',
    DELETE_ALARM: '/users/delete-alarm',
    UPDATE_USER: '/users',
    DELETE_USER: '/users',
    UPDATE_PASSWORD: '/users/update-pw',
    UPDATE_MARKETING: '/users/marketing',
    UPDATE_USER_IMAGE: '/users/user-image',
    DELETE_USER_IMAGE: '/users/user-image',
  },
  PROJECT: {
    FETCH_PROJECT: '/projects',
    DELETE_PROJECT: '/projects',
    CREATE_PROJECT: '/projects',
    UPDATE_PROJECT: '/projects',
    FETCH_PROJECTS: '/projects/project-list',
    FETCH_ALL_PROJECTS: '/projects/all-project-list',
    UPDATE_MODEL: '/projects/save-model',
    FETCH_CHECK_PROJECT_NAME: '/projects/check-project-name',
    UPDATE_PROJECT_IMAGE: '/projects/project-image',
    UPDATE_PROJECT_NAME: '/projects/update-project-name',
    UPDATE_HYPERPARAMETER: '/projects/update-hyperparameter',
    UPDATE_MODEL_HYPERPARAMETER: '/projects/update-model-hyperparameter',
    CREATE_COPY_PROJECT: '/projects/copy',
  },
  BLOCK: {
    FETCH_FRAMEWORKS: '/blocks/framework-list',
    FETCH_BLOCKS: '/blocks',
    CREATE_CODE: '/blocks/generate-code',
    CREATE_CODE_FILE_AS_BLOB: '/blocks/download-code',
    FETCH_IMAGE_PREPROCESSING: '/blocks/image-preprocessing',
    CREATE_PREVIEW_IMAGE_AS_BLOB: '/blocks/preview-image',
  },
};

export default API_END_POINT;
